import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

import { I18nPipe } from '../../pipes/i18n.pipe';

type Variant = 'danger' | 'warn' | 'success' | 'default';

@Component({
  selector: 'umkt-confirm-modal',
  standalone: true,
  imports: [CommonModule, I18nPipe],
  templateUrl: './confirm-modal.component.html',
  styleUrl: './confirm-modal.component.scss'
})
export class ConfirmModalComponent {
  @Input() open = false;
  @Input() title = 'components.confirmModal.defaultTitle';
  @Input() message = 'components.confirmModal.defaultMessage';
  @Input() icon = '';
  @Input() variant: Variant = 'default';
  @Input() confirmText = 'components.confirmModal.confirm';
  @Input() cancelText = 'shared.buttons.cancel';
  @Input() dismissible = true;

  @Output() confirm = new EventEmitter<void>();
  @Output() canceled = new EventEmitter<void>();
  @Output() closed = new EventEmitter<void>();

  @Output() result = new EventEmitter<boolean>();

  private readonly headerClassByVariant: Record<Variant, string> = {
    default: 'modal-header',
    danger:  'modal-header modal-header--danger',
    warn:    'modal-header modal-header--warn',
    success: 'modal-header modal-header--success',
  };

  private readonly iconClassByVariant: Record<Variant, string> = {
    default: 'icon-default',
    danger:  'icon-danger',
    warn:    'icon-warn',
    success: 'icon-success',
  };


  onBackdropClick(e: MouseEvent) {
    if (!this.open || !this.dismissible) return;
    this.emitCancel();
  }

  onConfirm() {
    this.confirm.emit();
    this.result.emit(true);
    this.onCloseInternally();
  }

  onCancelClick() {
    if (!this.dismissible) return;
    this.emitCancel();
  }

  private emitCancel() {
    this.canceled.emit();
    this.result.emit(false);
    this.onCloseInternally();
  }

  private onCloseInternally() {
    this.closed.emit();
  }

  get headerClass(): string {
    return this.headerClassByVariant[this.variant];
  }

  get iconClass(): string {
    return `${this.icon} ${this.iconClassByVariant[this.variant]}`;
  }
}